export default __webpack_public_path__ + "static/media/1314 utensils top.2dbcfd79.png";